import * as Opentype from 'opentype.js'
import Rectangle from 'abstractions/Rectangle'

export default class BoundingBox {
  static validate (bbox) {
    return !Object.values(bbox).some(v => isNaN(v))
  }

  constructor ({ xmin, xmax, ymin, ymax }) {
    if (!BoundingBox.validate({ xmin, xmax, ymin, ymax })) {
      throw new Error('Bounding box malformation: expected input is `{ xmin, xmax, ymin, ymax }`')
    }

    this.xmin = xmin
    this.xmax = xmax
    this.ymin = ymin
    this.ymax = ymax

    this.rectangle = new Rectangle({
      x: this.xmin,
      y: this.ymin,
      width: this.width,
      height: this.height
    })
  }

  get width () { return Math.abs(this.xmax - this.xmin) }
  get height () { return Math.abs(this.ymax - this.ymin) }
  get ratio () { return this.width / this.height }
  get center () { return [this.xmin + this.width / 2, this.ymin + this.height / 2] }

  static fromOpentypePath (path) {
    if (!(path instanceof Opentype.Path)) {
      throw new TypeError('Path should be a valid Opentype.Path instance')
    }

    const { x1: xmin, x2: xmax, y1: ymin, y2: ymax } = path.getBoundingBox()
    return new BoundingBox({ xmin, xmax, ymin, ymax })
  }

  static fromBBoxArray (bboxes = []) {
    let xmin = Number.POSITIVE_INFINITY
    let ymin = Number.POSITIVE_INFINITY
    let xmax = Number.NEGATIVE_INFINITY
    let ymax = Number.NEGATIVE_INFINITY

    bboxes.forEach(bbox => {
      if (bbox.xmin < xmin) xmin = bbox.xmin
      if (bbox.ymin < ymin) ymin = bbox.ymin
      if (bbox.xmax > xmax) xmax = bbox.xmax
      if (bbox.ymax > ymax) ymax = bbox.ymax
    })

    return new BoundingBox({ xmin, xmax, ymin, ymax })
  }

  static empty (x = 0, y = 0) {
    return new BoundingBox({ xmin: x, ymin: y, xmax: x, ymax: y })
  }

  intersects (bbox) {
    if (!(bbox instanceof BoundingBox)) {
      throw new TypeError('Cannot check the intersection to a non BoundingBox instance')
    }

    return this.xmin < bbox.xmax &&
      this.xmax > bbox.xmin &&
      this.ymin < bbox.ymax &&
      this.ymax > bbox.ymin
  }

  vnode (props = {}) {
    return <rect x={this.xmin} y={this.ymin} width={this.width} height={this.height} {...{ ...props }} />
  }
}



// WEBPACK FOOTER //
// ./src/abstractions/BoundingBox.js